const row = {
  namespaced: true,
  state: {
    edit_mongolia: false,
    edit_mongolia_horizontal: false,
    moduleID: null,
    sort_disabled:false,
    mb_edit:{
      isShow: false,
      top:0,
      left:0,
      select_row:null,
      timer:null

    },
    fixed:{
      top:0,
      fixeding:false
    },
    click_edit_row_btn:null
  },
  mutations: {
    SET_edit_mongolia(state, val) {
      state.edit_mongolia = val;
    },
    SET_edit_mongolia_horizontal(state, val) {
      state.edit_mongolia_horizontal = val;
    },
    SET_moduleID(state, val) {
      state.moduleID = val;
    },
    set_sort_disabled(state, val) {
      state.sort_disabled = val;
    },
    Reset_mb_edit(state) {
      if(state.mb_edit.timer){
        clearTimeout(state.mb_edit.timer);
      }
      state.mb_edit.isShow = false;
      state.mb_edit.top = 0;
      state.mb_edit.left = 0;
      state.mb_edit.timer = null;
      state.mb_edit.select_row = null;
    },
    SET_click_edit_row_btn(state,obj){
      state.click_edit_row_btn = obj;
    }


  },
  actions: {


  }

};


export default row;



// WEBPACK FOOTER //
// ./src/vuex/modules/row.js